'use client';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';

import { Dropdown } from '@/components/atoms';

export function SeasonsDropdown() {
	const router = useRouter();
	const searchParams = useSearchParams();
	const currentPath = usePathname();

	const seasonOptions = [
		{ value: '2024_winter', label: '2024 Winter Season (Current)' },
		{ value: '2024_fall', label: '2024 Fall Season' },
		{ value: '2024_summer', label: '2024 Summer Season' },
		{ value: '2024_spring', label: '2024 Spring Season' },
		{ value: '2023_winter', label: '2023 Winter Season' },
		{ value: '2023_summer', label: '2023 Summer Season' },
		{ value: '2023_spring', label: '2023 Spring Season' },
		{ value: 'inaugural', label: 'Inaugural Season first season long season title' }
	];

	const handleSeasonSelect = (value: string | number) => {
		const params = new URLSearchParams(searchParams.toString());

		params.set('seasonType', String(value));
		router.push(`${currentPath}?${params.toString()}`);
	};

	return (
		<div className="mb-5">
			<Dropdown options={seasonOptions} placeholder="Select a Season" onSelect={handleSeasonSelect} />
		</div>
	);
}
